<template>
<!-- 审核文件后复核-预约用药 -->
  <div class="appointment" v-if="!isLoading">
    <div class="appointment-container">
        <!-- 邮寄驳回提示 -->
        <!-- <div class="upload-status" v-if="(itemStatus=='审核不通过')&&showReasons" >
          <div class="status"><img width="16px" style="margin-right:3px;" src="/static/upload/refuseIcon.png" />邮寄材料审核不通过</div>
          <div class="reason">驳回原因：<br />
            <div v-for="item,index in reasons" :key="index">
              {{item.name}}: {{getReason(item.result.reason)}}; <br />
            </div>
          </div>
        </div> -->

        <!-- <div class="appointment-list" style="margin-bottom:40px;" v-if="phase_1"> -->
        <!-- <div class="appointment-list" style="margin-bottom:40px;" >
          <van-cell-group  :border="false">
            <template #title>
              <span class="custom-title">{{text1}}</span>
            </template>
            
            <van-cell :border="false">   
              <div style="color:#9D9D9D;white-space:nowrap;">患者姓名：</div>   <div>{{patient_name}}</div> 
            </van-cell>
            <van-cell :border="false">   
              <div style="color:#9D9D9D;white-space:nowrap;">当前轮次、周期：</div>   <div>第{{rounds}}轮次 第{{rounds_phase}}周期</div> 
            </van-cell>
            <van-cell :border="false">   
              <div class="alignment-flex">
                <div style="color:#9D9D9D;white-space:nowrap;">项目药房：</div>   <div>{{drugstore}}</div> 
              </div>
            </van-cell>
            <van-cell :border="false">   
              <div class="alignment-flex">
                <div style="color:#9D9D9D;white-space:nowrap;">药房地址：</div>   <div>{{drugstore_address}}</div> 
              </div>
            </van-cell>
            <van-cell :border="false">
                <div style="color:#9D9D9D;white-space:nowrap;">药房联系方式：</div>   <div>{{drugstore_phone}}</div> 
            </van-cell>
            <van-cell :border="false">
              <div class="alignment-flex">
                <div style="color:#9D9D9D;white-space:nowrap;">公益专员联系方式：</div>   
                  <div v-if="volunteer_name" style="word-break:normal;">{{volunteer_name}}/ {{volunteer_phone}}</div> 
                  <div v-else style="word-break:normal;">暂无</div>
              </div>
            </van-cell>

            <van-cell :border="false"> </van-cell>
          </van-cell-group>
        </div> -->

        <div class="appointment-list">
          <van-cell-group  :border="false">
            <template #title>
              <span class="custom-title">{{text2}}</span>
            </template>
            <van-cell :border="false" @click="goUpload(item)" v-for="item,index in items" :key="index">
              <template #title>
                <span class="custom-title">
                  <!-- <span class="custom-title" :style="{color:citem.result.status=='审核不通过'?'red':''}"> -->
                  <div :style="{'color':item.result.status=='审核不通过'?'red':''}">{{item.name}}</div>
                    <div class="appointment-status" v-if="item.result.status=='审核不通过'" >
                      <div class="img-status">
                        <img width="16px" style="margin-right:4px;margin-top:4px;" src="/static/upload/refuseIcon.png" />
                        驳回原因：{{item.result.reasons}}
                      </div>
                    </div>
                </span>
              </template>
              <div style="width:100%;display:flex;justify-content:center;">
                <img :src="getImgSrc(item.result.status,item)" width="55px" height="55px" />
                <!-- <img :src="getImgSrc('待审核', { attach: [] })" width="55px" /> -->
              </div>
            </van-cell>
          </van-cell-group>
        </div>

        
      <!-- <div v-if="!phase_1">
        <div class="appoint-notice">
            <div v-if="toggleText" style="font-size:14px;color:red;margin:5px;">*本次需要您前往项目医生处完成一次随访评估。</div>
            <div v-else  style="font-size:14px;color:red;margin:5px;">*项目办建议每3个月前往项目医生处完成一次随访评估。</div>
          <div class="address" style="font-size:13px;line-height:200%;">
            <div>*随访评估所需要的材料有：</div>
            <div v-for="item,index in mailItems" :key="index" >
              <div>{{index+1}}、{{item.name}}</div>
            </div>
          </div>
        </div>

        <div class="appoint-notice" >
          <div class="address">
            <div class="copyAddress">
              <div style="font-size:16px;">邮寄地址:</div>
              <van-button v-clipboard:copy="copyText"  @click="toastText('复制成功!')" 
                type="primary" size="small" plain color="#0AA8AF">复制地址</van-button>
            </div>
            <div>{{copyText}}</div>
            <div style="font-size:12px;color:#0AA8AF;margin-top:10px;">请您将随访材料邮寄至上方邮寄地址（只接收EMS特快专递），如有问题请联系项目办： 010-56592455。</div>
          </div>
        </div>
        <div style="font-size:12px;text-align:center;margin-bottom:50px;margin:0 10px;">
          <span v-if="field_3||field_4">*您最近一次的随访</span>
          <span v-if="field_3">时间是{{field_3}}</span>
          <span v-if="field_3&&field_4">，</span>
          <span v-if="field_4">检查部位是：{{field_4}}</span>
        </div>
      </div> -->


    </div>
    <div class="btn" >
        <van-button type="default" class="up " @click="goNext" :disabled="disabled" :disable="nextBtnDisabled" color="#0AA8AF">{{btntxt}}</van-button>
        <!-- <van-button v-if="active != 0" type="default" class="back" @click="toPrev()">上一步</van-button> -->
    </div>
  </div>
</template>
<script>
import {
  GetPatient,
  CheckItemStatus,
  GetCheckItem,
  UploadPatientStatus,
} from "../../api/api";
import Vue from "vue";
import { mapState } from "vuex";
import { Toast, Notify } from "vant";

Vue.use(Toast);
export default {
  data() {
    return {
      text1: "基础信息",
      text2: "填写信息上传材料",
      btntxt:"提交",
      disabled:false,//禁用提交按钮
      isLoading:true,//加载中不显示按钮
      category:"后续复核",

      patient_name:'',
      mode_type:'',
      rounds:'1',
      rounds_phase:'1',
      drugstore:'',
      drugstore_address:'',
      drugstore_phone:'',
      volunteer_phone:'',
      volunteer_name:'',
      // field_3:'',
      // field_4:"",

      nextBtnDisabled:false,
      active:'0',

      papid:"",
      patient_id:"",

      info:[{}],
      items:[],
      mailItems:[],
      // phase_1:false,//第一轮次时,显示基础信息,不显示邮寄材料;非第一轮次时,不显示基础信息,显示邮寄材料
      copyText:"北京市100024信箱59号分箱 中国初级卫生保健基金会“择美同行-患者援助项目办公室”（只接受EMS特快专递）",
      toggleText:false,

      itemStatus:'',//邮寄审核状态
      reasons:[],//邮寄驳回原因
      // showReasons:true,//显示邮寄驳回

    };
  },
  computed: {
    ...mapState(['patientOne', 'userInfo','patientInfo']),
  },
  async created(){
  },
  async mounted() {
      if (this.$route.query.active) {
        this.active = parseInt(this.$route.query.active);
      }
      if (this.$route.query.follow) {
        this.follow = this.$route.query.follow;
      }
      // console.log(this.active, this.$route.query)
      if (this.userInfo.patient) {
        this.papid = this.userInfo.patient.papid
        this.patient_id = this.userInfo.patient.id
      }

      await this.getData()
      window.localStorage.setItem('ischeck', 'true')
      this.$forceUpdate()
    },
  methods: {
    async getData() {
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true
        });
        // let res = await GetPatient({
        //   papid: this.papid
        // })
        let res={data:this.patientInfo}
        const {
          patient,
          drugstore,
          phase,
          predict,
          volunteer,
          mode_name,
          rounds_phase,
          phase_drug_field,
        } = res.data;
        console.log(res.data)
        this.patient_name=patient.name;
        this.mode_type=mode_name;
        this.rounds=patient.rounds;
        this.rounds_phase=rounds_phase;
        this.drugstore=drugstore.name;
        this.drugstore_address=drugstore.address;
        this.drugstore_phone=drugstore.druggist_phone;
        this.volunteer_phone=volunteer.mobile;
        this.volunteer_name=volunteer.name;
        // this.phase_1=rounds_phase==1?true:false;
        // if(phase_drug_field){
        //   this.field_3=phase_drug_field.field_3;
        //   this.field_4=phase_drug_field.field_4;
        // }




        let ci = await GetCheckItem({
          papid: this.papid,
          category: this.category,
          phase: res.data.patient.receive_phase
        })
        console.log(ci.data[0].data)


        //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!项目轮次特殊设置!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        //所有轮次
        if(rounds_phase==1){//第一周期时,不需要上一次用药凭证
          this.items=[]
          ci.data[0].data.forEach(ele=>{
            if(ele.name!="上一次援助药品用药凭证") this.items.push(ele)
          })
        }else{//后续周期
          //拍照上传全部
          // this.showReasons=false;//不显示邮寄驳回
          this.items=ci.data[0].data
          // this.mailItems=ci.data[0].data
        }
        // if(phase.rounds==1){//第一轮
        //   if(rounds_phase==1){//第一周期时,不需要上一次用药凭证
        //     this.items=[]
        //     ci.data[0].data.forEach(ele=>{
        //       if(ele.name!="上一次援助药品用药凭证") this.items.push(ele)
        //     })
        //   }else{//第一轮第二周期
        //     //拍照上传全部,邮寄全部
        //     this.showReasons=false;//不显示邮寄驳回
        //     this.items=ci.data[0].data
        //     this.mailItems=ci.data[0].data
        //   }
        // } else{//第二,三轮
        // console.log("第二,三轮")
        //   if(rounds_phase==1){//第一周期时,不需要上一次用药凭证
        //     console.log("第一周期")
        //     ci.data[0].data.forEach(ele=>{
        //       if(ele.name!="上一次援助药品用药凭证") this.items.push(ele)
        //     })
        //   }else{//2-11周期
        //     console.log("2-11周期")
        //     // console.log("2,6,10周期材料上传一半,邮寄一半",['2','6','10'].includes(rounds_phase),rounds_phase)
        //     if(['2','6','10'].includes(rounds_phase)) {
        //       this.toggleText=true;
        //       ci.data[0].data.forEach(ele=>{
        //         if(ele.is_required!=1){//非必填项为邮寄材料
        //           this.mailItems.push(ele)
        //         }else{//必填项为拍照上传材料
        //           this.items.push(ele)
        //         }
        //       })
        //     }else{//非2,6,10周期材料全部上传,不邮寄
        //       this.items=ci.data[0].data
        //       this.mailItems=[]
        //       ci.data[0].data.forEach(ele=>{
        //         this.mailItems.push({name:ele.name,result:{}})
        //       })
        //     }
        //   }
        // }
       //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

        this.mailItems.forEach(ele=>{
          if(ele.result.status=="审核不通过"){
            this.itemStatus="审核不通过"
            this.reasons.push(ele)
          }
        })

        Toast.clear()
        this.isLoading = false
      },
      goUpload(item, name) {
        console.log("goUpload", item.category)
        console.log(item.id)
        console.log(this.papid)
        console.log(item.category)
        console.log(this.active)
        console.log(this.follow)
        this.$router.push({
          name: 'UploadItem',
          query: {
            id: item.id,
            papid: this.papid,
            category: item.category,
            active: this.active,
            follow: this.follow
          }
        })
      },
    //通过状态计算图片地址
    getImgSrc(status, item) {
      const fileUrl = "/static/upload/";
      const format = ".png";
      let imgName = "awaitUpload";
      // console.log(item,status)
      if (status == "审核不通过") {
        imgName = "refuse";
      } else if (status == "审核通过") {
        imgName = "passed";
      } else if (status == "待审核" && item.attach.length > 0) {
        //已上传
        imgName = "uploaded";
      } else if (status == "待审核") {
        //未上传
        imgName = "awaitUpload";
      } else {
        console.log("getImgSrc出错");
      }
      imgName = fileUrl + imgName + format;

      return imgName;
    },
    //下一步
    goNext(){
        let item = this.items
        let allup = true
        console.log("item",item)
        for (let i in item) {
          let ele = item[i]
          console.log("ele",ele)
          if (ele.result.status == "未上传" || ele.attach.length < 1) {
            if (ele.is_required == "1") {
              allup = false
              Toast('请完善资料')
              return
            }
          } else if (ele.result.status == "审核不通过") {
            Toast('您有驳回的材料，请重新上传')
            allup = false
            return
          }
        }
        if(allup){
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true
          });
          UploadPatientStatus({
            papid: this.papid,
            category: [this.category],//后续复核
          }).then(res => {
            this.$router.replace({
              name: "Timeline",
            });
            Toast.clear();
          }).catch(err => {
            this.disabled = false;
            Toast.clear();
            Toast(err.response.data.message);
          })
        }
    },
    toastText(text){
      Toast(text)
    },
    getReason(reason){
      let str='';
      reason.forEach(ele=>{
        str+=ele
      })
      return str
    }


  },
};
</script>
<style lang="less">
.appointment {
  height: 100%;
  // min-height: 90vh;
  width: 100%;
  //   margin-bottom: 50px;
  box-sizing: border-box;
  .appointment-container{
    min-height: calc(90vh - 50px);
    .upload-status {
      box-sizing: border-box;
      padding: 10px 15px;
      margin: 16px;
      border-radius: 10px;
      overflow: hidden;
      background-color: #FFDADB;
      font-size: 14px;
      color:#FF4830;
      .status{
        display: flex;
        align-items: center;
      }
      &.red {
        color: @red;
      }
    }
  
  .appointment-list {
    box-sizing: border-box;
    margin: 16px;
    border-radius: 10px;
    box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0);
    overflow: hidden;
    .van-cell__title {
      flex: 5;
    }
    .van-cell__value{
      flex: 2;
      display:flex;
      justify-content:flex-start;
      align-items:center;
      .alignment-flex{
        display:flex;
        justify-content:flex-start;
        align-items:flex-start;
      }
    }
    .appointment-status {
      box-sizing: border-box;
    //   padding: 10px 15px;
    //   margin: 16px;
      border-radius: 10px;
      overflow: hidden;
    //   background-color: #FFDADB;
      font-size: 14px;
      color:#FF4830;
      .img-status{
        display: flex;
        align-items: flex-start;
      }
      &.red {
        color: @red;
      }
    }
  }
  .van-cell-group__title {
    background: #0aa8af;
    color: #fff;
    padding: 10px;
    .custom-title{
      margin-left: 20px;
    }
    &::after {
      content: "";
      width: 4px;
      height: 15px;
      background-color: #e8f4a6;
      position: absolute;
      left: 30px;
      border-radius: 2px;
    }
  }


  .appoint-notice{
    box-sizing: border-box;
    margin: 16px;
    border-radius: 10px;
    box-shadow: 0px 1px 10px 0px rgba(3, 121, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0);
    overflow: hidden;
        .address{
          box-sizing: border-box;
          margin: 5px 16px 16px 16px;
          border-radius: 10px;
          overflow: hidden;
          font-size: 14px;
          .appointment-status {
            box-sizing: border-box;
          //   padding: 10px 15px;
          //   margin: 16px;
            border-radius: 10px;
            overflow: hidden;
          //   background-color: #FFDADB;
            font-size: 14px;
            color:#FF4830;
            .img-status{
              display: flex;
              align-items: center;
            }
            &.red {
              color: @red;
            }
          }
        .status{
          color:#FF4830;
          margin: 0 0 16px 0;
          display: flex;
          align-items: center;
        }
        .copyAddress{
            margin: 10px 0;
            display: flex;
            justify-content:space-between;
        }
      }
  }
  }
}
</style>